var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"highlight-current":"","check-strictly":"","data":_vm.data,"props":_vm.defaultProps,"default-checked-keys":[_vm.checkedID],"node-key":_vm.treeNodeKey,"auto-expand-parent":false,"default-expand-all":true,"config":_vm.config,"show-checkbox":_vm.config.multiple},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }